import type { ToastContainerProps } from 'react-toastify';

// Top-right rather than the bottom-left it used to be: F10's queue dock owns the whole bottom edge,
// so a toast down there would land on it. While a song is on screen they move aside again — see
// `.toasts-beside-lyrics` in index.css.
export const TOAST_CONTAINER_PROPS = {
  position: 'top-right',
  theme: 'colored',
  limit: 3,
} satisfies Partial<ToastContainerProps>;
